import React from "react";
import ZonesTable from "./ZonesTable";
import ContentCard from "../../Common/Layout/ContentCard";
import Body from "../../Common/Body";

const Sellers = () => {
  return (
    <Body title={"Lista de zonas"}>
      <ContentCard>
        <ZonesTable></ZonesTable>
      </ContentCard>
    </Body>
  );
};

export default Sellers;
